// SEO Component for Volepse.me
// This component handles dynamic SEO meta tags based on the current view

export const SEO_CONFIG = {
  client: {
    title: "Volepse.me - Βόλεψε Με! | Χρειάζεσαι Βύσμα; Έχουμε Χιλιάδες!",
    description: "Χρειάζεσαι βύσμα; Ξέρεις κάποιον με μέσον; Το Volepse.me σε συνδέει με χιλιάδες επαγγελματίες fixers που λύνουν ΟΛΑ τα προβλήματα. Άδειες, χαρτιά, ραντεβού - γρήγορα και διακριτικά!",
    keywords: "βύσμα, μέσον, γνωριμίες, άδειες, δημόσιο, χαρτιά, ραντεβού γιατρού, επιδοτήσεις, volepse, βόλεψε με, fixers, connections greece",
    ogTitle: "Volepse.me - Βόλεψε Με! | Το Μεγαλύτερο Δίκτυο Βυσμάτων",
    ogDescription: "Λύσε τα προβλήματά σου με τα σωστά μέσα! 5000+ βύσματα σε όλη την Ελλάδα. Από άδειες μέχρι ραντεβού - όλα γρήγορα και διακριτικά.",
  },
  fixer: {
    title: "Volepse.me - Γίνε Fixer! | Βγάλε Λεφτά από τις Γνωριμίες σου",
    description: "Έχεις γνωριμίες; Ξέρεις κόσμο; Γίνε επαγγελματίας fixer και βγάλε λεφτά! 70-85% προμήθεια, εβδομαδιαίες πληρωμές, χιλιάδες πελάτες. Εγγραφή 100% δωρεάν!",
    keywords: "fixer, γνωριμίες, βγάλε λεφτά, side hustle, επιχειρηματικότητα, offshore accounts, παθητικό εισόδημα, fixers greece, γίνε μέλος",
    ogTitle: "Volepse.me - Γίνε Fixer και Βγάλε Λεφτά!",
    ogDescription: "Μετέτρεψε τις γνωριμίες σου σε εισόδημα! 70-85% προμήθεια, offshore λογαριασμοί, VIP υποστήριξη. Ξεκίνα σήμερα!",
  }
};

// JSON-LD Schema for Client View
export const CLIENT_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Professional Connection Services",
  "name": "Volepse.me - Υπηρεσίες Επαγγελματικών Συνδέσεων",
  "description": "Σύνδεση με επαγγελματίες fixers για άδειες, χαρτιά, ραντεβού γιατρού, επιδοτήσεις και άλλες υπηρεσίες που χρειάζονται γνωριμίες.",
  "provider": {
    "@type": "Organization",
    "name": "Volepse.me"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Greece"
  },
  "offers": [
    {
      "@type": "Offer",
      "name": "Μικρό Βύσμα",
      "price": "25",
      "priceCurrency": "EUR",
      "description": "Για απλές δουλειές - 1-2 συνδέσεις τον μήνα"
    },
    {
      "@type": "Offer",
      "name": "Σοβαρό Βύσμα",
      "price": "100",
      "priceCurrency": "EUR",
      "description": "Για σοβαρές δουλειές - 5-10 συνδέσεις τον μήνα με προτεραιότητα"
    },
    {
      "@type": "Offer",
      "name": "VIP Βύσμα",
      "price": "500",
      "priceCurrency": "EUR",
      "description": "Για τους ειδικούς - απεριόριστες συνδέσεις και VIP υποστήριξη"
    }
  ]
};

// JSON-LD Schema for Fixer View
export const FIXER_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "JobPosting",
  "title": "Γίνε Επαγγελματίας Fixer",
  "description": "Βγάλε λεφτά από τις γνωριμίες σου! Γίνε μέλος του μεγαλύτερου δικτύου fixers στην Ελλάδα.",
  "hiringOrganization": {
    "@type": "Organization",
    "name": "Volepse.me",
    "sameAs": "https://volepse.me"
  },
  "jobLocation": {
    "@type": "Place",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "GR"
    }
  },
  "employmentType": "CONTRACTOR",
  "baseSalary": {
    "@type": "MonetaryAmount",
    "currency": "EUR",
    "value": {
      "@type": "QuantitativeValue",
      "minValue": 70,
      "maxValue": 85,
      "unitText": "PERCENT"
    }
  },
  "benefits": "Ελευθερία ωραρίου, offshore λογαριασμοί, VIP υποστήριξη, εβδομαδιαίες πληρωμές"
};

// FAQ Schema for better SEO
export const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Τι είναι το Volepse.me;",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Το Volepse.me είναι η μεγαλύτερη πλατφόρμα σύνδεσης με επαγγελματίες fixers στην Ελλάδα. Συνδέουμε ανθρώπους που χρειάζονται βοήθεια σε διοικητικά θέματα με επαγγελματίες που έχουν τις κατάλληλες γνωριμίες και εμπειρία."
      }
    },
    {
      "@type": "Question",
      "name": "Πόσο κοστίζει το Volepse.me;",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Προσφέρουμε 3 πακέτα: Μικρό Βύσμα (€25/μήνα), Σοβαρό Βύσμα (€100/μήνα), και VIP Βύσμα (€500/μήνα). Κάθε πακέτο προσφέρει διαφορετικό επίπεδο υπηρεσιών και προτεραιότητας."
      }
    },
    {
      "@type": "Question",
      "name": "Πώς μπορώ να γίνω fixer;",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Η εγγραφή είναι 100% δωρεάν! Κάνεις εγγραφή, επαληθεύουμε τις γνωριμίες σου, και αρχίζεις να δέχεσαι αιτήματα. Κερδίζεις 70-85% από κάθε δουλειά ανάλογα με το επίπεδό σου."
      }
    },
    {
      "@type": "Question",
      "name": "Είναι νόμιμο;",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Απόλυτα! Το Volepse.me λειτουργεί ως πλατφόρμα σύνδεσης επαγγελματιών. Όλες οι συναλλαγές γίνονται με διαφάνεια και σύμφωνα με την ελληνική νομοθεσία."
      }
    }
  ]
};

